var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pp-button-expand__wrap"},[_c('pButton',{ref:"button",attrs:{"type":"primary","circle":"","icon":_vm.icon},on:{"click":_vm.click}}),_c('transition',{on:{"enter":_vm.enter,"after-enter":_vm.after,"leave":_vm.enter,"after-leave":_vm.after}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showExpand),expression:"showExpand"}],class:[
                'pp-button-expand',
                `is-${_vm.direction}`,
            ]},[_vm._t("expand")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }